import { createShipmentCreationSlice } from '@/modules/shipment-creation/createShipmentSlice';
import { OUTBOUND_CONFIG } from '@/modules/shipment-creation/configs';

const outbound = createShipmentCreationSlice(OUTBOUND_CONFIG);

export const outboundSliceActions = outbound.actions;
export const outboundSliceSelectors = outbound.selectors;

export const {
  setStep,
  goToNextStep,
  goToPreviousStep,
  updateBasicDetails,
  updateParty,
  clearParty,
  updateCargo,
  triggerValidation,
  hideValidation,
  resetForm,
  loadDraftData,
  setSyncStatus,
  setShipmentId,
  setSyncError,
  clearSyncState,
} = outbound.actions;

export const selectCreateOutbound = outbound.selectors.selectRoot;
export const selectCurrentStep = outbound.selectors.selectCurrentStep;
export const selectFormData = outbound.selectors.selectFormData;
export const selectBasicDetails = outbound.selectors.selectBasicDetails;
export const selectCargo = outbound.selectors.selectCargo;
export const selectValidation = outbound.selectors.selectValidation;
export const selectShowErrors = outbound.selectors.selectShowErrors;
export const selectSync = outbound.selectors.selectSync;
export const selectIsDirty = outbound.selectors.selectIsDirty;
export const selectShipmentId = outbound.selectors.selectShipmentId;

export type { ShipmentCreationStep as CreateOutboundStep } from '@/modules/shipment-creation/types';
export type { ShipmentParty as OutboundParty } from '@/modules/shipment-creation/types';
export type { ShipmentOrganizationLocation as OutboundOrganizationLocation } from '@/modules/shipment-creation/types';
export type { ShipmentBasicDetailsData as OutboundBasicDetailsData } from '@/modules/shipment-creation/types';
export type { ShipmentCargoStepData as OutboundCargoStepData } from '@/modules/shipment-creation/types';
export type { ShipmentCreationFormData as CreateOutboundFormData } from '@/modules/shipment-creation/types';
export type { ShipmentSyncStatus as OutboundSyncStatus } from '@/modules/shipment-creation/types';
export type { ShipmentSyncState as OutboundSyncState } from '@/modules/shipment-creation/types';
export type { ShipmentPartyType as OutboundPartyType } from '@/modules/shipment-creation/types';
export type { ValidationErrors } from '@/modules/shipment-creation/types';
export type { ShipmentCreationState as CreateOutboundState } from '@/modules/shipment-creation/types';

export default outbound.reducer;
